import React from 'react';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  searchInput: {
    display: 'flex',
    alignItems: 'center',
    height: '36px',
    borderRadius: '4px',
    backgroundColor: 'white',
    maxWidth: '620px',
    flexGrow: 1,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  searchInputIcon: {
    color: theme.palette.text.primary,
    opacity: 0.5,
    marginRight: theme.spacing(1),
  },
  searchInputText: {
    width: '100%',
  },
}));

const SearchInput = ({ onChage, placeholder }) => {
  const classes = useStyles();

  return (
    <div className={classes.searchInput}>
      <SearchIcon className={classes.searchInputIcon} />
      <InputBase
        className={classes.searchInputText}
        onChange={onChage}
        placeholder={placeholder ? placeholder : 'Search'}
      />
    </div>
  );
};

export default SearchInput;
